import { useDispatch } from 'react-redux';
import { similarProductsFetch } from '@client/product/redux/similarProducts/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useFetchSimilarProducts = (): typeof similarProductsFetch => {
  const dispatch = useDispatch();

  return bindActionCreators(similarProductsFetch, dispatch);
};
